import { useAppDispatch } from "core/utils";
import { useParams } from "react-router";

import { CardAttributeEditForm } from "src/app/features/CardImplementation/subFeatures/CardDefinition/subFeatures/CardAttribute/components/forms/CardAttributeEditForm";
import { ActionBar } from "../../../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../../../../../components/FeatureButtons/CancelButton";
import { HistoryButton } from "../../../../../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../../../../../core/router/auth";
import { ResourceName } from "../../../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../../../../../core/setup/redux/state/tabs/tabState";

export const CardAttributeEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const { cardImplementationId, cardDefinitionId, id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardImplementationId}/${ResourceName.CARD_DEFINITIONS}/${cardDefinitionId}/${ResourceName.CARD_ATTRIBUTES}/${id}/${FORM_ACTION.HISTORY}`;
    const backUrl = `${BASE_PATH}/${ResourceName.CARD_IMPLEMENTATIONS}/${cardImplementationId}/${ResourceName.CARD_DEFINITIONS}/${FORM_ACTION.EDIT}/${cardDefinitionId}`;

    const dispatch = useAppDispatch();
    const setTabsDefaultBeforeBack = () => dispatch(setDefaultActiveKey("card-implementations_cardAttributes"));

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.cardAttributesEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton isDisabled={false} url={backUrl} onBeforeNavigate={setTabsDefaultBeforeBack} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CardAttributeEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
